<template>
  <div
    style="
      height: 100vh;
      overflow-y: scroll;
      background-image: url('');
      background-size: cover;
      padding-bottom: 15rem;
      background-attachment: fixed;
    "
  >
    <div
      class="form-group pt-4 d-flex justify-content-between px-2"
      style="width: 100%"
    >
      <div>
        <h2>{{ $route.query.provider || "Buffalo" }}</h2>
      </div>
      <div>
        <input
          v-model="name"
          type="text"
          class="form-control game-search"
          placeholder="Search Game Name"
        />
      </div>
    </div>
    <div
      class="p-0 d-flex flex-wrap mb-5 justify-content-center flex-shrink-1 px-1"
      style="width: 100%"
    >
      <div
        class="card game-card p-0 m-1 col-4"
        v-show="game.gameName !== 'lobby'"
        v-for="(game, index) in newGames.length > 0 ? newGames : games"
        :key="index"
        @click="
          $playSound();
          gameInit(game);
        "
      >
        <img
          :src="imageLinkGenerate(game.gameID)"
          style="
            width: 100%;
            height: 100%;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
          "
        />
        <span
          class="py-2 pb-2 px-3 text-uppercase"
          style="
            font-size: 0.8rem;
            color: white;
            font-weight: 550;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            white-space: nowrap;
          "
          >{{ game.gameName }}</span
        >
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#ffffff" class="mx-auto" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      games: [],
      rows: 0,
      provider: "Buffalo",
      name: null,
      newGames: [],
      option1: [
        { text: "Pragmatic Play", value: "Pragmatic" },
        { text: "Jili", value: "Jili" },
        { text: "Play Star", value: "Playstar" },
        { text: "Fast Spin", value: "Fastspin" },
        { text: "Spade Gaming", value: "Spade" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    imageLinkGenerate(gameId) {
      const provider = this.$route.query.provider || "Buffalo";
      if (provider === "Jili") {
        return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/jili/GAMEID_${gameId}_EN.png`;
      }
      if (provider === "Spade") {
        return `https://api-egame-staging.sgplay.net/thumbnail/en_US/${gameId}.jpg`;
      }
      if (provider === "Fastspin") {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (provider === "Playstar") {
        return `/build/assets/img/playstar/${gameId}.png`;
      }
      if (provider === "JDB") {
        return `https://dlntdk2it99.anhuidingyue.com/jdb-assetsv3/games/${gameId}/${gameId}_en.png`;
      }
      if (provider === "Buffalo") {
        return `https://api.prerelease-env.biz/game_pic/rec/325/${gameId}.png`;
      }
      return `https://api.prerelease-env.biz/game_pic/rec/325/${gameId}.png`;
    },
    async fetchGames() {
      try {
        this.isLoading = true;
        const res = await axios.get("/games", {
          params: {
            provider: this.$route.query.provider || "Buffalo",
          },
        });

        this.games = res.data.data || [];
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
          return;
        }

        const res = await axios.get("/games/url", {
          params: {
            gameID: game.gameID,
            provider: this.$route.query.provider || "Buffalo",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        window.top.location.href = res.data.data.gameUrl;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
  watch: {
    provider() {
      this.fetchGames();
    },
    name() {
      this.newGames = this.games.filter((game) =>
        game.gameName.toLowerCase().includes((this.name || "").toLowerCase()),
      );
    },
    "$route.query.provider"() {
      this.fetchGames();
    },
  },
  mounted() {
    this.fetchGames();
  },
};
</script>
<style scoped>
.provider-dropdown {
  width: 200px;
  height: 40px;
}

.game-search {
  width: 17rem !important;
  height: 3rem;
  border: 1px solid #000000;
  background: transparent;
  color: black;
}

.game-card {
  flex-basis: 30% !important;
  flex-grow: 1;
  background: rgba(2, 79, 165, 0.8);
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  height: auto;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
